import { createFileRoute } from '@tanstack/react-router';


export const Route = createFileRoute('/app/customers')({
  // Deep-link contract: ?q= presets the customer search.
  validateSearch: (search) => ({
    q: typeof search.q === 'string' ? search.q : undefined,
  }),
});
